import React from 'react';
import './style.scss';
import { PlanogramData } from './hooks';
import { IMAGE_URL } from '../../../../config/envConf';

interface Props {
    planogramList: PlanogramData[][];
    // eslint-disable-next-line no-unused-vars
    renderModalDelete: (item: PlanogramData) => React.ReactElement;
    // eslint-disable-next-line no-unused-vars
    renderModalUpdate: (item: PlanogramData) => React.ReactElement;
}

function RenderMenuStyle(props: Props) {
  const {
    planogramList, renderModalDelete, renderModalUpdate,
  } = props;
  return (
    <div className="px-4 px-xl-5">
      {planogramList.map((data, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i}>
          {data.map((item) => (
            <div
              key={item.id}
              style={{ height: '200px', borderBottom: '1px solid #F3F4F8' }}
              className="d-flex align-items-center w-100"
            >
              <div
                style={{ width: '50px', backgroundColor: '#F3F4F8' }}
                className="flexible-center fz-14 color-placeholder h-100"
              >
                {item.apCode}
              </div>
              <div className="flexible-center ms-2 ms-lg-3 ms-xl-4 mb-1">
                <img src={`${IMAGE_URL}${item.productImage}`} alt="productImg" width={60} />
              </div>
              <div className="flex-grow-1 mx-2 mx-lg-3 mx-xl-4 fz-14">
                <div className="fz-14 planogram-desc mb-2 w-100" style={{ maxWidth: '500px' }}>{item.productName}</div>
                <div className="d-flex fz-14">
                  <div style={{ width: '100px' }}>
                    {`$${item.price}`}
                  </div>
                  <div>{`Qty: ${item.quantity}`}</div>
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                {renderModalDelete(item)}
                {renderModalUpdate(item)}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default React.memo(RenderMenuStyle);
